import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  canAnswer: false,
  reason: '',
  totalCount: 0,
  pageCount: 0,
  columns: [],
  entities: null,
  reportId: '',
  error: null,
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const aiReportsSlice = createSlice({
  name: "aiReports",
  initialState: initialState,
  reducers: {
    aiReportsFetched: (state, action) => {
      const {canAnswer, reason, columns, totalCount, pageCount, entities, reportId} = action.payload;
      state.listLoading = false;
      state.canAnswer = canAnswer;
      state.reason = reason;
      state.totalCount = totalCount;
      state.pageCount = pageCount;
      state.columns = columns;
      state.entities = entities;
      state.reportId = reportId;
      state.error = null;
    },
    aiReportsAppended: (state, action) => {
      const {canAnswer, reason, columns, totalCount, pageCount, entities, reportId} = action.payload;
      state.listLoading = false;
      state.canAnswer = canAnswer;
      state.reason = reason;
      state.totalCount = totalCount;
      state.pageCount = pageCount;
      state.columns = columns;
      state.entities = state.entities ? [...state.entities, ...entities] : [...entities];
      state.reportId = reportId;
      state.error = null;
    },
    resetState: () => initialState,
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});